const Info = {
  github: "https://github.com/japhmayor",
  twitter: "https://twitter.com/bontusss",
  facebook: "https://facebook.com/bontus.mayor",
  linkedIn: "https://linkedin.com/in/ikwechegh-ukandu",
};

export default Info;
